/*
 * @Author: Teemo Ding
 * @Date: 2021-12-03 16:16:18
 * @LastEditTime: 2023-02-10 15:11:15
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/createOrder.ts
 */
import { get, post, remove } from 'src/tools/server';
export const applyDiscount = (data, params = {}) => {
  return post<any>(`/portal/order/create/applyDiscount`, data, { ...params });
};

export const buyerPage = (data) => {
  return post<any>(`/portal/order/create/buyerPage`, data, {});
};

export const billingAddressPage = (data) => {
  return post<any>(`/portal/order/create/billingAddressPage`, data, {});
};

export const recipientPage = (data) => {
  return post<any>(`/portal/order/create/recipientPage`, data, {});
};

export const senderPage = (data) => {
  return post<any>(`/portal/order/create/senderPage`, data, {});
};
export const getVouchers = (data, params = {}) => {
  return post<any>(`/portal/order/create/vouchers`, data, { ...params });
};

export const getCustomerDetail = (customerUuid: string) => {
  return get<any>(`/portal/customer/detail/${customerUuid}`, {});
};

export const saveCreateOrder = (data, params = {}) => {
  return post<any>(`/portal/order/create/save`, data, { ...params });
};

export const getDeliveryFee = (data) => {
  return post<any>(`/portal/order/create/deliveryFee`, data, {});
};

export const getTaxes = (data) => {
  return post<any>(`/portal/order/create/taxes`, data, {});
};
export const getCreateFees = (data, params = {}) => {
  return post<any>(`/portal/order/create/fees`, data, { ...params });
};

export const getLockerZones = (data) => {
  return post<any>(`/portal/order/create/locker/zones`, data, {});
};

export const getLockerPartners = (data) => {
  return post<any>(`/portal/order/create/locker/partners`, data, {});
};

export const getLockerPickup = (salesChannelUuid) => {
  return get<any>(`/portal/order/create/pickup/${salesChannelUuid}`, {});
};

export const getLockerDeliveryMethods = (data) => {
  return post<any>(`/portal/order/create/deliveryMethods`, data, {});
};

export const getCreateOrderDetail = (orderUuid) => {
  return get<any>(`/portal/order/create/detail/${orderUuid}`, {});
};
export const placeCreateOrder = (data) => {
  return post<any>(`/portal/order/create/place`, data, {});
};
export const deleteOrder = (orderUuid) => {
  return remove<any>(`/portal/order/create/delete/${orderUuid}`, {});
};

export const getSalesChannelConfig = (data) => {
  return post<any>(`/portal/order/create/salesChannelConfig`, data, {});
};

export const orderCreateNotify = (data) => {
  return post<any>(`/portal/order/create/notify`, data, {});
};
